import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_StudentFinesDebts } from "./shared/data.service";
import { StudentAddFineComponent } from "./student-add-fine/student-add-fine.component";
import { StudentAdjustFineComponent } from "./student-adjust-fine/student-adjust-fine.component";
import { StudentFineDetailsComponent } from "./student-fine-details/student-fine-details.component";
import { StudentFineRefundComponent } from "./student-fine-refund/student-fine-refund.component";
import { StudentPayFineComponent } from "./student-pay-fine/student-pay-fine.component";
import * as moment from "moment";

@Component({
	selector: "app-student-fines-debts",
	templateUrl: "./student-fines-debts.component.html",
	styleUrls: ["./student-fines-debts.component.css"],
})
export class StudentFinesDebtsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private StudentFinesDebtsService: DataService_StudentFinesDebts,
		private selectService: PersonSelectorService,
		private dialogService: DialogService,
		private reportService: ReportService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;

			this.loadCurrentBalance();
			this.loadFine();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	NotPaidOnly: any = 0;
	lstNotPaidOnly: any = [
		{
			ID: 0,
			Desc: "All Items",
		},
		{
			ID: 1,
			Desc: "Only Items with Balance",
		},
	];

	OrderAsc: any = 1;
	lstOrderAsc: any = [
		{
			ID: 1,
			Desc: "Oldest First",
		},
		{
			ID: 0,
			Desc: "Newest First",
		},
	];

	//Current balance
	BalanceText: any = "Current Balance:";
	CurrentBalance: any = 0;
	CurrentBalanceDesc: any = "$0.00";

	subscription: Subscription;
	SelectedPerson: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedFine: any;
	lstFine: any = [];

	//Filter lists
	lstFineTypeDesc: any = [];
	lstPartOfGroupAction: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FineDateDesc", header: "Date/Time" },
		{ field: "FineTypeDesc", header: "Fine Type" },
		{ field: "AmountDesc", header: "Charged" },
		{ field: "WaivedDesc", header: "Adjusted" },
		{ field: "PaidDesc", header: "Paid" },
		{ field: "BalanceDesc", header: "Balance" },
		{ field: "FineComment", header: "Comments" },
		{ field: "PartOfGroupAction", header: "Part of Group Action" },
		{ field: "GroupName", header: "GroupName" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadCurrentBalance() {
		if (this.SelectedPerson == undefined) {
			this.CurrentBalance = 0;
			this.CurrentBalanceDesc = "$0.00";

			return;
		}

		var result = this.StudentFinesDebtsService.LoadCurrentBalance(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				var Data: any = response;

				if (Data.length > 0) {
					this.CurrentBalance = response[0];
					this.CurrentBalanceDesc = "$" + this.CurrentBalance;
				} else {
					this.CurrentBalance = 0;
					this.CurrentBalanceDesc = "$0.00";
				}
			},
			(error) => {}
		);
	}

	loadFine() {
		this.loading = true;

		if (this.SelectedPerson == undefined) {
			this.lstFine = [];
			this.lstFineTypeDesc = [];

			this.loading = false;

			return;
		}

		var result = this.StudentFinesDebtsService.LoadFine(this.SelectedPerson.PersonID, this.NotPaidOnly, this.OrderAsc, this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				this.lstFine = response;

				for (var i = 0; i < this.lstFine.length; i++) {
					var next = this.lstFine[i];

					next.FineDateDesc = moment(new Date(next.FineDate)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstFineTypeDesc = Array.from(new Set(this.lstFine.map((item: any) => item.FineTypeDesc))).sort();
				this.lstPartOfGroupAction = Array.from(new Set(this.lstFine.map((item: any) => item.PartOfGroupAction))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadFine();
		this.loadCurrentBalance();
	}

	//Custom Button Methods
	onAddFine() {
		this.errorMessage = "";

		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == -1) {
			this.errorMessage = "Select a person to add a fine";
			return;
		}

		var ref = this.dialogService.open(StudentAddFineComponent, {
			header: "Add Fine",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedPerson: this.SelectedPerson,
				CurrentBalance: this.CurrentBalance,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadFine();
				this.loadCurrentBalance();
			}
		});
	}

	onPayFine() {
		this.errorMessage = "";

		// if(this.SelectedFine == undefined){
		//   this.errorMessage = "Select a fine to pay or waive";

		//   return;
		// }

		var ref = this.dialogService.open(StudentPayFineComponent, {
			header: "Pay/Waive Fine",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedPerson: this.SelectedPerson,
				CurrentBalance: this.CurrentBalance,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadFine();
				this.loadCurrentBalance();
			}
		});
	}

	onRefund() {
		this.errorMessage = "";

		if (this.SelectedFine == undefined) {
			this.errorMessage = "Select a fine to refund";
			return;
		}

		if (this.SelectedFine.TransactionType == "D") {
			this.confirmationService.confirm({
				key: "main",
				acceptLabel: "Ok",
				rejectVisible: false,
				message:
					"Cannot refund fines/money that is owed. Users can only refund payments a student has made. If you wish to remove a fine, use Adjust or Pay/Waive fine's Manual mode to waive the amount of the fine.",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		} else {
			var ref = this.dialogService.open(StudentFineRefundComponent, {
				header: "Refund Payment",
				width: "fit-content",
				data: {
					//INSERT Custom Data here
					user: this.user,
					SelectedPerson: this.SelectedPerson,
					SelectedFine: this.SelectedFine,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.onRowUnselect(null);
					this.loadFine();
					this.loadCurrentBalance();
				}
			});
		}
	}

	onAdjust() {
		this.errorMessage = "";

		if (this.SelectedFine == undefined) {
			this.errorMessage = "Select a Fine to adjust";
			return;
		} else if (this.SelectedFine.CanAdjust == false) {
			this.errorMessage = "Cannot adjust this fine";
			return;
		} else {
			var ref = this.dialogService.open(StudentAdjustFineComponent, {
				header: "Adjust Fine",
				width: "fit-content",
				data: {
					//INSERT Custom Data here
					user: this.user,
					SelectedPerson: this.SelectedPerson,
					SelectedFine: this.SelectedFine,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.onRowUnselect(null);
					this.loadFine();
					this.loadCurrentBalance();
				}
			});
		}
	}

	onViewDetails() {
		this.errorMessage = "";

		if (this.SelectedFine == undefined) {
			this.errorMessage = "Select a Fine to View Details";
			return;
		}

		var ref = this.dialogService.open(StudentFineDetailsComponent, {
			header: "View Details",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedPerson: this.SelectedPerson,
				CurrentBalance: this.CurrentBalance,
				SelectedFine: this.SelectedFine,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadFine();
				this.loadCurrentBalance();
			}
		});
	}

	onPrintHistory() {
		this.errorMessage = "";

		//Error handling

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		var strParam = "";

		// @PersonID
		// @NotPaidOnly
		// @AccountID
		// @OrderAsc

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: NotPaidOnly
		strParam += "," + this.NotPaidOnly + "|NotPaidOnly"; //

		//Parameter 3: AccountID
		strParam += "," + "1" + "|AccountID";

		//Parameter 4: OrderAsc
		strParam += "," + this.OrderAsc + "|OrderAsc"; //

		var reportID: any = 229;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onNotPaidOnlyChange(val) {
		this.NotPaidOnly = val;

		this.loadFine();
		this.loadCurrentBalance();
	}

	onOrderAscChange(val) {
		this.OrderAsc = val;

		this.loadFine();
		this.loadCurrentBalance();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedFine = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedFine = null;
	}
	onRowDblClick(Fine) {
		this.errorMessage = "";

		this.SelectedFine = Fine;
		this.onViewDetails();
	}
	////////////////////////////////////////////
}
